import { useQuery } from '@tanstack/react-query';
import { useAxios } from './use-axios';
import { loadTvProgramGuide } from '../api/load-tv-program-guide';
import { loadTvProgramGuideNonSrg } from '../api/load-tv-program-guide-non-srg';
import { queryKeys } from '../config/use-query';
export const useTvGuideChannel = (date, channel) => {
  const axios = useAxios();
  const {
    data,
    isLoading,
    isError
  } = useQuery({
    queryKey: [queryKeys.TvProgramGuideChannel(date, channel?.id ?? ''), {
      channel
    }, axios],
    queryFn: () => {
      if (!channel) return undefined;
      if (channel.type === 'srg') {
        return loadTvProgramGuide(date, axios, [channel.businessUnit], false, channel.id);
      }
      return loadTvProgramGuideNonSrg(date, axios, false, channel.id);
    },
    enabled: !!channel
  });
  return {
    extendedProgram: data && data[0],
    isLoading,
    isError
  };
};